// Intl.NumberFormat is missing the French locale in default Node builds, resulting in a wrong SSR output
export const formatMoney = (amount: number): string => {
  const str = Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace(".", ",")
  return str + " €"
}

export const parseQueryString = (search: string): Record<string, string> => {
  const tuples = search.substr(1).split("&")
  const data: Record<string, string> = {}
  tuples.forEach((tuple) => {
    const [key, value] = tuple.split("=")
    data[key] = decodeURIComponent(value)
  })
  return data
}
